import { Box } from "@mui/material"
import { useState } from "react";

const ProductMainImage = ({src,width,height}) =>{
    const DEFAULT_PRODUCT_IMAGE =
  "https://via.placeholder.com/300x300?text=No+Image";
    const [imgSrc, setImgSrc] = useState(src || DEFAULT_PRODUCT_IMAGE);
    return (
        <Box>
            <img src={imgSrc} width={width} height={height} style={{objectFit:'contain'}}  onError={() => setImgSrc(DEFAULT_PRODUCT_IMAGE)} />
        </Box>
    )
}

export default ProductMainImage